import {defineField, defineType} from 'sanity'
import {BiTag} from 'react-icons/bi'
import dotcomDestination from '../fragments/dotcom.destination'
import dotcomShip from '../fragments/dotcom.ship'
import {createUniqueFieldValidator} from '../../lib/validations'

export default defineType({
  name: 'blog.category',
  title: 'Category',
  type: 'document',
  icon: BiTag,
  groups: [{name: 'content', default: true}, {name: 'cruises'}, {name: 'metadata'}],
  fields: [
    defineField({
      name: 'cluster',
      type: 'reference',
      group: 'content',
      to: [{type: 'blog.category-cluster'}],
      // This ensures we cannot select other "children"
      // options: {
      //   filter: '!defined(cluster)',
      // },
    }),
    defineField({
      name: 'title',
      type: 'string',
      group: 'content',
      validation: (rule) =>
        rule
          .required()
          .custom(
            createUniqueFieldValidator(
              'blog.category',
              'title',
              'A category with this title already exists',
            ),
          ),
    }),
    defineField({
      name: 'categorySubtitle',
      title: 'Subtitle',
      description: 'This field is dedicated to the hero of the video category page.',
      type: 'string',
      group: 'content',
    }),
    defineField({
      name: 'mainContent',
      title: 'Main Content',
      description: 'This content will be displayed on the top of the category page.',
      type: 'portableText',
      group: 'content',
    }),
    defineField({
      name: 'secondaryContent',
      title: 'Secondary Content',
      description: 'This content will be displayed on the bottom of the category page.',
      type: 'portableText',
      group: 'content',
    }),
    defineField({
      name: 'selectedArticles',
      title: 'Selected Articles',
      type: 'array',
      of: [{type: 'reference', to: [{type: 'blog.post'}], weak: true}],
      group: 'content',
    }),
    defineField({...dotcomDestination, group: 'content'}),
    defineField({...dotcomShip, group: 'content'}),
    defineField({
      name: 'excludeFromInternalSearch',
      type: 'boolean',
      title: 'Exclude from internal search',
      description: 'Exclude the posts in this category from the internal search results',
      group: 'metadata',
    }),
    defineField({
      name: 'cruiseFilters',
      type: 'cruise-filters',
      group: 'cruises',
    }),
    defineField({
      name: 'metadata',
      type: 'metadata',
      group: 'metadata',
    }),
    defineField({
      name: 'wpId',
      type: 'number',
      title: 'WordPress ID',
      description: 'WordPress category ID for sync tracking',
      group: 'metadata',
      readOnly: true,
    }),
  ],
  preview: {
    select: {
      title: 'title',
      subtitle: 'cluster.title',
    },
    prepare: ({title, subtitle}) => ({
      title,
      subtitle: subtitle ? `- ${subtitle}` : ``,
    }),
  },
})
